/**
 * @author Rahul Nainala
 * @description This Component is used to only display Custom Hierarchy Tree
 */
import './styles.css';
import { Card, message, Tree, Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { getHierarchy, getModuleListbyId } from './apicalls';

let ViewAssetsTree = (props) => {
  const [moduleData, setModuleData] = useState({});
  const [treeData, setTreeData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);

  const handleExpand = (expandedKeysValue) => {
    setExpandedKeys(expandedKeysValue);
  };
  useEffect(() => {
    try {
      const idFromUrl = props.location.pathname.split('/');
      const fetchModuleData = async () => {
        const ModuleData = await getModuleListbyId(idFromUrl[3]);
        setModuleData(ModuleData[0]);
      };
      fetchModuleData();
    } catch (e) {
      message.error('Unable to Load Modules');
      console.error('Error :', e);
    }
  }, [props.location.pathname]);

  useEffect(() => {
    const loadHierarchy = async () => {
      if (Object.keys(moduleData).length === 0) return;
      const propstoHierarchy = {
        LevelType: 'Module',
        Code: moduleData.Name,
        Type: 'module',
        parent: null,
        nextlevels: []
      };
      try {
        const hierarchyData = await getHierarchy(propstoHierarchy);
        if (hierarchyData && hierarchyData.length > 0) {
          setTreeData(formatTreeData(hierarchyData));
          setExpandedKeys(getAllKeys(hierarchyData));
        } else message.error('No Data Exists');
      } catch (e) {
        message.error('Error handling hierarchy data ', e);
      }
    };
    loadHierarchy();
  }, [moduleData]);

  const getAllKeys = (nodes) => {
    let keys = [];
    nodes.forEach((node) => {
      keys.push(node.Id);
      if (node.nextLevels) {
        keys = keys.concat(getAllKeys(node.nextLevels));
      }
    });
    return keys;
  };

  const formatTreeData = (data) => {
    if (!Array.isArray(data)) {
      message.error('Expected data to be an array but got:', data);
      return [];
    }
    return data.map((item) => ({
      Id: item.Id,
      title: item.name || item.Code,
      key: item.key,
      levelType: item.LevelType,
      type: item.Type,
      parentId: item.ParentId,
      maxLimit: item.MaxLimit,
      minLimit: item.MinLimit,
      nextLevels: item.nextLevels ? formatTreeData(item.nextLevels) : []
    }));
  };

  const renderTreeNodes = (nodes) => {
    return nodes.map((node) => ({
      title: node.title,
      key: node.Id,
      children: node.nextLevels ? renderTreeNodes(node.nextLevels) : []
    }));
  };

  return (
    <>
      <div>
        <Button
          style={{ marginLeft: '20px' }}
          onClick={() => props.navigate('/rubus/customHierarchy')}
        >
          Go Back
        </Button>
      </div>
      <div style={{ display: 'flex', padding: '20px', justifyContent: 'center' }}>
        <div style={{ width: '50%', marginRight: '20px' }}>
          <Card
            className="card-tree"
            title="Hierarchy Tree"
            style={{ minHeight: window.innerHeight - 150, color: '#fffff'}}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', height: '100%' }}>
              <div
                style={{
                  flexGrow: 1,
                  overflowY: 'auto',
                  maxHeight: '800px',
                  background: '#1a3652'
                }}
              >
                <Tree
                  showLine
                  selectable={false}
                  onExpand={handleExpand}
                  expandedKeys={expandedKeys}
                  treeData={renderTreeNodes(treeData)}
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ViewAssetsTree;
